export default __webpack_public_path__ + "static/InfoDesign-00d70f789db61373711198b11fef90e7.pdf";